import {Button, Card, Table, Row, message} from 'antd';
import {useEffect, useState} from 'react';
import {getBuyer, getInvoiceLines, insertReturn} from "../../api/Api";
import {BuyerInvoiceProfile} from '../sales/BuyerInvoiceProfile';
import {ReturnModal} from "./ReturnModal";
import {displayToFixedUnit, fixedToDisplayUnit} from "../../util/unitutils";

export const InvoiceView = ({invoice, onApiFail, onCancel, onRefresh, props}) => {
    const [buyer, setBuyer] = useState(undefined);
    const [invoiceLines, setInvoiceLines] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [returnLine, setReturnLine] = useState(undefined);
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        getBuyer(invoice.buyerId).then(r => {
            setBuyer(r);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });

        getInvoiceLines(invoice.id).then(lines => {
            setInvoiceLines(lines.map(l => {
                return {...l, key: l.id }
            }))
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }, [onApiFail, invoice]);

    const openModal = (invoiceLine) => () => {
        setReturnLine(invoiceLine);
        setIsModalOpen(true);
    }

    const onModalCancel = () => {
        setIsModalOpen(false);
    }

    const onModalOk = (quantity, refundAmount, accountId, notes) => {
        const fixedQuantity = displayToFixedUnit(quantity, returnLine.unit);
        insertReturn(invoice.id, returnLine.id, returnLine.inventoryId, fixedQuantity, refundAmount, accountId, notes)
            .then(r => {
                messageApi.open({
                    type: 'success',
                    content: 'Refund Processed Successfully'
                })
            }).catch(e => {
                if ((e.status === 401) && (onApiFail)) {
                    onApiFail();
                }
                messageApi.open({
                    type: 'error',
                    content: 'Failed to Insert Refund'
                })
            })
        setIsModalOpen(false);
        if (onRefresh) onRefresh();
    }

    const columns = [
        {
            title: "Name",
            dataIndex: 'name',
            key: 'name',
            render: (val, record, index) => {
                return <div style={{cursor: 'pointer'}} onClick={openModal(record)}>{val}</div>
            }
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description'
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity',
            render: (val, record) => {
                const displayQuantity = fixedToDisplayUnit(val, record.unit);
                return displayQuantity;
            }
        },
        {
            title: 'Price',
            dataIndex: 'linePrice',
            key: 'linePrice',
            render: (val, record, index) => {
                return <div>{(record.linePrice === undefined) ? undefined : `$ ${record.linePrice}`}</div>
            }
        },
        {
            title: 'Discount',
            dataIndex: 'lineDiscount',
            key: 'lineDiscount',
            render: (val, record, index) => {
                return  `${ val}`;
            }
        }
    ];

    const buyerContent = (buyer === undefined) ? <div /> : <BuyerInvoiceProfile buyer={buyer} onApiFail={onApiFail} />

    const topStyle = {
        textAlign: 'left'
    }
    return <div style={topStyle}>
        <Row><Button onClick={onCancel}>Back</Button></Row>
        <p/>
        {contextHolder}
        <Card>
        <Row><b>
            Invoice: {invoice.invoiceNumber}
        </b></Row>
        </Card>

        {buyerContent}
        <Card title={'Select the Item to Return'}>
            <Table columns={columns} dataSource={invoiceLines} pagination={false} />
        </Card>
        <ReturnModal open={isModalOpen} onOk={onModalOk} onCancel={onModalCancel} invoice={invoice} invoiceLine={returnLine} onApiFail={onApiFail}/>
    </div>
}